var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOtherbank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    rx: 24,
    fill: "#00DFA2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.4154 7.16602L12.332 32.9993V43.3327H110.499V32.9993M84.6654 53.666V89.8327H100.165V53.666M12.332 115.666H110.499V100.166H12.332M53.6654 53.666V89.8327H69.1654V53.666M22.6654 53.666V89.8327H38.1654V53.666H22.6654Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtherbank);
export default __webpack_public_path__ + "static/media/other bank.aaf0274fafb9eb9077e23af90569201f.svg";
export { ForwardRef as ReactComponent };